export default [
  {
    path: '/window',
    name: 'window',
    component: () => import('@/layouts/main/Window'),
    children: [
      {
        path: 'inbound',
        name: 'window.inbound',
        component: () => import('@/views/Window/Inbound'),
        meta: {
          pageTitle: ''
        }
      },
      {
        path: 'inbound/select-member',
        name: 'window.inbound.select-member',
        component: () => import('@/views/Window/InboundSelectMember'),
        meta: {
          pageTitle: ''
        }
      },
      {
        path: 'outbound/:id/consultation/:consultationId',
        name: 'window.consultation.outbound.edit',
        component: () => import('@/views/Window/Consultation/Outbound/Edit'),
        meta: {
          pageTitle: 'Edit Outbound'
        }
      },
      {
        path: 'outbound/:id/edit-consultation/:consultationId',
        name: 'window.consultation.edit',
        component: () => import('@/views/Window/Consultation/Edit'),
        meta: {
          pageTitle: ''
        }
      },
      {
        path: 'outbound/:id/view-consultation/:consultationId',
        name: 'window.consultation.view',
        component: () => import('@/views/Window/Consultation/View'),
        meta: {
          pageTitle: ''
        }
      },
      {
        path: 'outbound/select-members',
        name: 'window.consultation.outbound.select-members',
        component: () => import('@/views/Window/Consultation/SelectMembers'),
        meta: {
          pageTitle: ''
        }
      },
      {
        path: 'outbound/:id',
        name: 'window.consultation.outbound',
        component: () => import('@/views/Window/Outbound'),
        meta: {
          pageTitle: ''
        }
      },
      {
        path: 'queue-status',
        name: 'window.queue.status',
        component: () => import('@/views/Window/Queues/Status/Index'),
        meta: {
          pageTitle: ''
        }
      },
      {
        path: 'queue-status/v2',
        name: 'window.queue.status.v2',
        component: () => import('@/views/Window/Queues/Status/V2/Index'),
        meta: {
          pageTitle: ''
        }
      },
      {
        path: 'queue-status/label/edit/:id',
        name: 'window.queue.status.label.edit',
        component: () => import('@/views/Window/Queues/Status/Label/Edit'),
        meta: {
          pageTitle: ''
        }
      },
      {
        path: 'queue-status-report',
        name: 'window.queue.status.report',
        component: () => import('@/views/Window/Queues/StatusReport'),
        meta: {
          pageTitle: ''
        }
      },
      {
        path: 'queue-all',
        name: 'window.queue.status.all',
        component: () => import('@/views/Window/Queues/Status/All/Index'),
        meta: {
          pageTitle: ''
        }
      },
      {
        path: 'consultation-recording-file',
        name: 'window.consultation.recording.file',
        component: () => import('@/views/Window/Consultation/Recording/File'),
        meta: {
          pageTitle: ''
        }
      },
      {
        path: 'consultation-one-touch-recording-file',
        name: 'window.consultation.recording.one-touch-file',
        component: () => import('@/views/Window/Consultation/Recording/OneTouchFile'),
        meta: {
          pageTitle: ''
        }
      },
      {
        path: 'member/add',
        name: 'window.member.add',
        component: () => import('@/views/Window/Member/Add'),
        meta: {
          pageTitle: 'Add Member'
        }
      },
      {
        path: 'member/outbound/history/:id',
        name: 'window.consultation.history',
        component: () => import('@/views/Window/Consultation/History'),
        meta: {
          pageTitle: ''
        }
      },
      {
        path: 'member/outbound/list/:companyName',
        name: 'window.consultation.company.list',
        component: () => import('@/views/Window/Consultation/Company/List'),
        meta: {
          pageTitle: 'Outbound'
        }
      },
      {
        path: 'announcement/add',
        name: 'window.dashboard.announcement.add',
        component: () => import('@/views/Window/Dashboard/Announcement/Add'),
        meta: {
          pageTitle: 'Add Announcement'
        }
      },
      {
        path: 'announcement/edit/:id',
        name: 'cti.window.announcement.edit',
        component: () => import('@/views/Window/Dashboard/Announcement/Edit'),
        meta: {
          pageTitle: 'Edit Announcement'
        }
      },
      {
        path: 'view-announcement/:id',
        name: 'cti.window.announcement',
        component: () => import('@/views/Window/Dashboard/Announcement/View'),
        meta: {
          pageTitle: 'View Announcement'
        }
      },
      {
        path: 'send-sms/:number',
        name: 'cti.window.send-sms',
        component: () => import('@/views/Window/Messages/SMS'),
        meta: {
          pageTitle: 'Send Message'
        }
      },
      {
        path: 'add-message-template',
        name: 'cti.window.message-template.add',
        component: () => import('@/views/Window/Messages/Templates/Add'),
        meta: {
          pageTitle: 'Add Message Template'
        }
      },
      {
        path: 'edit-message-template/:id',
        name: 'cti.window.message-template.edit',
        component: () => import('@/views/Window/Messages/Templates/Edit'),
        meta: {
          pageTitle: 'Edit Message Template'
        }
      },
      {
        path: 'consultation/add-custom-field',
        name: 'cti.window.consultation.custom-field.add',
        component: () => import('@/views/Window/Configuration/Consultation/CustomField/Add'),
        meta: {
          pageTitle: 'Add Consultation Custom Field'
        }
      },
      {
        path: 'consultation/edit-custom-field/:id',
        name: 'cti.window.consultation.custom-field.edit',
        component: () => import('@/views/Window/Configuration/Consultation/CustomField/Edit'),
        meta: {
          pageTitle: 'Edit Consultation Custom Field'
        }
      },
      {
        path: 'caller-id/:id/users',
        name: 'cti.window.caller-id.users.edit',
        component: () => import('@/views/Window/Configuration/CallerId/Users/Edit'),
        meta: {
          pageTitle: 'Edit Caller Id Users'
        }
      },
      {
        path: 'user/add',
        name: 'cti.window.user.add',
        component: () => import('@/views/Window/User/Add'),
        meta: {
          pageTitle: 'add_user'
        }
      },
      {
        path: 'user/edit-permission/:id',
        name: 'cti.window.user.permission.edit',
        component: () => import('@/views/Window/User/Permission/Edit'),
        meta: {
          pageTitle: 'edit_user_permission'
        }
      },
      {
        path: 'project/add',
        name: 'cti.window.project.add',
        component: () => import('@/views/Window/Project/Add'),
        meta: {
          pageTitle: 'Project Task'
        }
      },
      {
        path: 'project/edit/:id',
        name: 'cti.window.project.edit',
        component: () => import('@/views/Window/Project/Edit'),
        meta: {
          pageTitle: 'Edit Project'
        }
      },
      {
        path: 'task/add',
        name: 'cti.window.task.add',
        component: () => import('@/views/Window/Task/Add'),
        meta: {
          pageTitle: 'Add Task'
        }
      },
      {
        path: 'task/edit-progress/:id',
        name: 'cti.window.task.edit-progress',
        component: () => import('@/views/Window/Task/Progress/Edit'),
        meta: {
          pageTitle: 'Edit Task Progress'
        }
      },
      {
        path: 'task/edit/:id',
        name: 'cti.window.task.edit',
        component: () => import('@/views/Window/Task/Edit'),
        meta: {
          pageTitle: 'Edit Task'
        }
      },
      {
        path: 'view-task/:id',
        name: 'cti.window.task',
        component: () => import('@/views/Window/Task/View'),
        meta: {
          pageTitle: 'View Task'
        }
      },
      {
        path: 'view-schedule/:id',
        name: 'cti.window.schedule',
        component: () => import('@/views/Window/Schedule/View'),
        meta: {
          pageTitle: ''
        }
      },
      {
        path: 'messages/edit-callback/:id',
        name: 'cti.window.messages.edit-callback',
        component: () => import('@/views/Window/Messages/CallbackNumber/Edit'),
        meta: {
          pageTitle: 'Edit Callback Number'
        }
      },
      {
        path: 'messages/category/add',
        name: 'cti.window.messages.category.add',
        component: () => import('@/views/Window/Messages/Category/Add'),
        meta: {
          pageTitle: 'Add Messages Category'
        }
      },
      {
        path: 'time-condition/add/:keyword/:type',
        name: 'cti.window.time-condition.add',
        component: () => import('@/views/Window/Timeconditions/Add'),
        meta: {
          pageTitle: 'Add Time Conditions'
        }
      },
      {
        path: 'time-condition/edit/:id/:keyword/:type',
        name: 'cti.window.time-condition.edit',
        component: () => import('@/views/Window/Timeconditions/Edit'),
        meta: {
          pageTitle: 'Edit Time Conditions'
        }
      },
      {
        path: 'transfer/history',
        name: 'cti.window.transfers.history',
        component: () => import('@/views/Window/Transfers/History'),
        meta: {
          pageTitle: 'Transfer History'
        }
      },
      {
        path: 'transfer/edit/:id',
        name: 'cti.window.transfers.edit',
        component: () => import('@/views/Window/Transfers/Edit'),
        meta: {
          pageTitle: 'Edit Transfer'
        }
      },
      {
        path: 'send-message',
        name: 'cti.window.send-message',
        component: () => import('@/views/Window/MessageManagement/SendMessage'),
        meta: {
          pageTitle: ''
        }
      },
      {
        path: 'outbound-popup/:phoneNumber?',
        name: 'cti.window.outbound-popup',
        component: () => import('@/views/Window/OutboundPopup'),
        meta: {
          pageTitle: ''
        }
      },
      {
        path: 'inbound-details',
        name: 'window.call-statistics.inbound-details',
        component: () => import('@/views/Window/CallStatistics/InboundDetailsPopup'),
        meta: {
          pageTitle: ''
        }
      },
      {
        path: 'outbound-details',
        name: 'window.call-statistics.outbound-details',
        component: () => import('@/views/Window/CallStatistics/OutboundDetailsPopup'),
        meta: {
          pageTitle: ''
        }
      },
      {
        path: 'inbound-statistics',
        name: 'window.call-statistics.inbound-statistics',
        component: () => import('@/views/Window/CallStatistics/InboundStatisticsPopup'),
        meta: {
          pageTitle: ''
        }
      },
      {
        path: 'call-statistics',
        name: 'window.call-statistics.call-statistics',
        component: () => import('@/views/Window/CallStatistics/CallStatisticsPopup'),
        meta: {
          pageTitle: ''
        }
      },
      {
        path: 'schedules/:date',
        name: 'window.schedule.date',
        component: () => import('@/views/Window/Schedule/Form'),
        meta: {
          pageTitle: ''
        }
      },
      {
        path: 'upload-sound-file',
        name: 'window.upload-sound-file',
        component: () => import('@/views/Window/SoundFile/Add'),
        meta: {
          pageTitle: ''
        }
      },
      {
        path: 'sound-files/:extension',
        name: 'window.sound-files',
        component: () => import('@/views/Window/SoundFile/List'),
        meta: {
          pageTitle: ''
        }
      },
      {
        path: 'auto-call-system/public/upload',
        name: 'window.upload-auto-call-system-public-data',
        component: () => import('@/views/Window/AutoCallSystemPublic/Upload'),
        meta: {
          pageTitle: ''
        }
      },
      {
        path: 'auto-call-system/public/export',
        name: 'window.export-auto-call-system-public-data',
        component: () => import('@/views/Window/AutoCallSystemPublic/Export'),
        meta: {
          pageTitle: ''
        }
      },
      {
        path: 'auto-call-system/public/delete',
        name: 'window.delete-auto-call-system-public-data',
        component: () => import('@/views/Window/AutoCallSystemPublic/Delete'),
        meta: {
          pageTitle: ''
        }
      },
      {
        path: 'auto-call-system/public',
        name: 'window.auto-call-system-public',
        component: () => import('@/views/Window/AutoCallSystemPublic/Dashboard'),
        meta: {
          pageTitle: ''
        }
      },
      {
        path: 'auto-call-system/upload',
        name: 'window.upload-auto-call-system-data',
        component: () => import('@/views/Window/AutoCallSystem/Upload'),
        meta: {
          pageTitle: ''
        }
      },
      {
        path: 'auto-call-system/export',
        name: 'window.export-auto-call-system-data',
        component: () => import('@/views/Window/AutoCallSystem/Export'),
        meta: {
          pageTitle: ''
        }
      },
      {
        path: 'auto-call-system/delete',
        name: 'window.delete-auto-call-system-data',
        component: () => import('@/views/Window/AutoCallSystem/Delete'),
        meta: {
          pageTitle: ''
        }
      },
      {
        path: 'auto-call-system',
        name: 'window.auto-call-system',
        component: () => import('@/views/Window/AutoCallSystem/Dashboard'),
        meta: {
          pageTitle: ''
        }
      },
      {
        path: 'call-note',
        name: 'window.call-note',
        component: () => import('@/views/Window/CallNote'),
        meta: {
          pageTitle: 'Call Note'
        }
      },
      {
        path: 'blacklist/add',
        name: 'cti.window.blacklist.add',
        component: () => import('@/views/Window/Blacklist/Add'),
        meta: {
          pageTitle: 'blacklist_task'
        }
      },
      {
        path: 'company/worktime/edit',
        name: 'cti.window.company.worktime.edit',
        component: () => import('@/views/Window/CompanyWorktime/Edit'),
        meta: {
          pageTitle: 'extension_status_working_hours_settings'
        }
      },
      {
        path: 'view-extension-status-data-analysis/:extension',
        name: 'window.extension-status-data-analysis.view',
        component: () => import('@/views/Window/ExtensionStatusDataAnalysis/View'),
        meta: {
          pageTitle: 'view_details'
        }
      },
      {
        path: 'time-conditions/sound-file/:index/:list',
        name: 'window.time-conditions.sound-file.add',
        component: () => import('@/views/Window/Timeconditions/SoundFile/Add'),
        meta: {
          pageTitle: ''
        }
      },
      {
        path: 'time-conditions',
        name: 'window..time-conditions',
        component: () => import('@/views/Window/TimeConditionsPopup'),
        meta: {
          pageTitle: ''
        }
      }
    ]
  }
]
